import gql from 'graphql-tag';

export default gql`
    query GetJobPlannedTrucks($jobId: Int!) {
        getJobPlannedTrucks(jobId: $jobId) {
            id
            jobId
            fromDate
            toDate
            trucksPerDay
            updatedBy
            updatedDate
        }
    }
`;
